export default __webpack_public_path__ + "static/media/customizeProfile.a2232cbc.svg";